import React, { useState, useMemo } from "react";
import Input from "../../../Elements/Input/Input";
import Button from "../../../Elements/Button/Button";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import esLocale from "@fullcalendar/core/locales/es";

export default function EditPermisos({ values, handleChange }) {

  const [newPerm, setNewPerm] = useState({ motivo: "", fecha: "", folio: "" });
  const [showCal, setShowCal] = useState(false);
  const [editing, setEditing] = useState(null); // { id, motivo, fecha, folio }
  const permisos = useMemo(() => values.permisos || [], [values.permisos]);

  const events = useMemo(
    () =>
      permisos.map((p) => ({
        id: p.id,
        title: p.motivo || "Permiso",
        start: p.fecha,
        allDay: true,
        extendedProps: { ...p },
      })),
    [permisos]
  );

  const canAdd =
    newPerm.motivo.trim() !== "" &&
    newPerm.fecha !== "" &&
    newPerm.folio.trim() !== "";
  const canSave =
    editing &&
    editing.motivo.trim() !== "" &&
    editing.fecha !== "" &&
    editing.folio.trim() !== "";

  // Agregar nuevo permiso con id único
  const handleAdd = () => {
    if (!canAdd) return;
    const id = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    const lista = [...permisos, { ...newPerm, id }];
    handleChange("permisos")({ target: { value: lista } });
    setNewPerm({ motivo: "", fecha: "", folio: "" });
  };

  // Click en evento del calendario
  const handleEventClick = ({ event }) => {
    const { id, motivo, fecha, folio } = event.extendedProps;
    setEditing({ id, motivo, fecha, folio });
    setShowCal(false);
  };

  // Cambios en modal de edición
  const handleEditChange = (field) => (e) =>
    setEditing({ ...editing, [field]: e.target.value });

  // Guardar edición usando id
  const saveEdit = () => {
    if (!canSave) return;
    const updated = permisos.map((p) =>
      p.id === editing.id
        ? { ...p, motivo: editing.motivo, fecha: editing.fecha, folio: editing.folio }
        : p
    );
    handleChange("permisos")({ target: { value: updated } });
    setEditing(null);
  };

  return (
    <div className="seccion-formulario">
      <h4>Permisos</h4>

      {/* Crear nuevo permiso */}
      <div className="row g-3 align-items-end">
        <div className="col-md-4">
          <Input
            label="Motivo"
            value={newPerm.motivo}
            onChange={(e) => setNewPerm({ ...newPerm, motivo: e.target.value })}
          />
        </div>
        <div className="col-md-4">
          <Input
            type="date"
            label="Fecha"
            value={newPerm.fecha}
            onChange={(e) => setNewPerm({ ...newPerm, fecha: e.target.value })}
          />
        </div>
        <div className="col-md-4">
          <Input
            label="Folio"
            value={newPerm.folio}
            onChange={(e) => setNewPerm({ ...newPerm, folio: e.target.value })}
          />
        </div>
        <div className="col-md-12">
          <Button
            text="Agregar"
            color="green"
            fill
            classNames="btn-sm"
            action={handleAdd}
            disabled={!canAdd}
          />
        </div>
      </div>
      {!canAdd && (
        <small className="text-danger row">
          Todos los campos son obligatorios para crear un permiso.
        </small>
      )}

      {/* Botón para abrir calendario */}
      <Button
        text="Ver calendario de permisos"
        color="blue"
        fill
        classNames="mt-3"
        action={() => setShowCal(true)}
      />

      {/* Modal Calendario */}
      {showCal && (
        <div
          className="modal d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Calendario de Permisos</h5>
                <button className="btn-close" onClick={() => setShowCal(false)} />
              </div>
              <div className="modal-body">
                <FullCalendar
                  plugins={[dayGridPlugin, interactionPlugin]}
                  initialView="dayGridMonth"
                  locale={esLocale}
                  headerToolbar={{
                    left: "prev,next today",
                    center: "title",
                    right: "",
                  }}
                  events={events}
                  eventClick={handleEventClick}
                  height="auto"
                  dayMaxEventRows={3}
                  dayMaxEvents
                  moreLinkContent={(args) => `+${args.num} más`}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Edición */}
      {editing && (
        <div
          className="modal d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content p-3">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Editar Permiso</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setEditing(null)}
                />
              </div>
              <Input
                label="Motivo"
                value={editing.motivo}
                onChange={handleEditChange("motivo")}
              />
              <Input
                type="date"
                label="Fecha"
                value={editing.fecha}
                onChange={handleEditChange("fecha")}
              />
              <Input
                label="Folio"
                value={editing.folio}
                onChange={handleEditChange("folio")}
              />
              {!canSave && (
                <small className="text-danger">
                  Completa todos los campos para guardar.
                </small>
              )}
              <div className="d-flex justify-content-end gap-2 mt-3">
                <Button
                  text="Guardar"
                  color="green"
                  action={saveEdit}
                  disabled={!canSave}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
